import React, { Fragment } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import { useNavigate } from "react-router-dom";
import { MdKeyboardArrowLeft } from "react-icons/md";
import DiningTablesPanel from "../components/custom/DiningTablesPanel";
import "../styles/style.css";

function DiningTables() {
  const navigate = useNavigate();

  return (
    <Fragment>
      <MasterLayout>
        <div className="rs-settings">
          <header className="rs-settings__header">
            <button
              type="button"
              className="rs-settings__back"
              onClick={() => navigate("/reservation-settings")}
            >
              <MdKeyboardArrowLeft /> More
            </button>
            <div className="rs-settings__heading">
              <div className="rs-settings__heading-text">
                <h1 className="rs-settings__title">Dining tables</h1>
                <p className="rs-settings__subtitle">
                  Manage seating tables, chair counts, and availability.
                </p>
              </div>
            </div>
          </header>
          <DiningTablesPanel />
        </div>
      </MasterLayout>
    </Fragment>
  );
}

export default DiningTables;
